import { makeStyles } from '@material-ui/core';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      width: 720,
      maxWidth: '100%',
    },
    dialogContent: {
      padding: theme.spacing(3, 4),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: theme.spacing(3),
    },
    checkboxLabel: {
      ...theme.typography.regular12,
      color: COLORS.gray.gray30,
    },
    shortField: {
      width: '344px',
    },
    field: {
      display: 'flex',
      flexFlow: 'column',
      alignSelf: 'stretch',
    },
    genToolLabel: {
      fontSize: theme.typography.pxToRem(14),
    },
    promptField: {
      margin: theme.spacing(1, 0, 2, 0),
      borderRadius: theme.shape.borderRadius,
    },
    action: {
      minWidth: 82,
      fontSize: theme.typography.pxToRem(16),
      fontWeight: theme.typography.fontWeightMedium,
      marginLeft: 0,
    },
    editable: {
      flex: 1,
      minHeight: '110px !important', //overrides styles of slate in case of placeholder
      maxHeight: '150px !important',
    },
    menuPaper: {
      maxHeight: 304,
    },
  }),
  { name: 'PopupFreestyleToolSave' }
);
